import { render, staticRenderFns } from "./BlockSlide.vue?vue&type=template&id=6a0d3e64"
import script from "./BlockSlide.vue?vue&type=script&lang=js"
export * from "./BlockSlide.vue?vue&type=script&lang=js"
import style0 from "./BlockSlide.vue?vue&type=style&index=0&id=6a0d3e64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.1__lodash@4_50f6069bc14464b8bd79aa1c8f71d64f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports